<template>
  <div style="height: 100%; overflow-y: hidden">
    <div class="topBox">
      <div class="maincontent">
        <el-row>
          <el-col :span="20" class="pt10">
            <span class="fgreen f20 pding10">武汉工商学院</span>|<span
              class="pd10 fgreen"
              >&nbsp;&nbsp;一站式服务大厅</span
            >
          </el-col>
          <el-col :span="4" class="tr">
            <!-- <el-link to="/serviceHome">用户登录</el-link> | -->
            
            <router-link to="/"> 学校首页</router-link>
          </el-col>
        </el-row>
      </div>
      <h3
        class="tc fgreen"
        style="margin-bottom: 20px;"
        :style="{ marginTop: mtvalue + 'px' }"
      >
        欢迎登录
      </h3>
      <div
        class="maincontent"
        style="
          width: 30%;
          background: #fff;
          box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.3);
          border-radius: 8px;
          padding: 10px 20px;
        "
      >
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="用户密码登录" name="first"> </el-tab-pane>
          <el-tab-pane label="手机验证登录" name="second"></el-tab-pane>
          <el-tab-pane label="微信扫码登录" name="third"></el-tab-pane>

          <el-form
            ref="formLabelAlign"
            label-width="80px"
            :model="formLabelAlign"
          >
            <div v-if="activeName == 'first'">
              <el-form-item label="用户名">
                <el-input
                  autocomplete="off"
                  v-model="formLabelAlign.name"
                ></el-input>
              </el-form-item>
              <el-form-item label="密   码">
                <el-input
                  autocomplete="off"
                  type="password"
                  v-model="formLabelAlign.pwd"
                ></el-input>
              </el-form-item>
              <el-form-item  >
                <el-button style="margin-left:20%" type="success" @click="submitForm('formLabelAlign')"
                  >登录</el-button
                >
                <el-button style="" @click="resetForm('formLabelAlign')">取消</el-button>
              </el-form-item>
            </div>
            <div v-if="activeName == 'second'">
              <el-form-item label="手机号">
                <el-input v-model="formLabelAlign.phoneNumber" style="width:60%;margin-right:5px"></el-input
                ><el-button type="primary" @click.prevent="sendCode()">发送验证码</el-button>
              </el-form-item>
               <el-form-item label="验证码">
                <el-input v-model="formLabelAlign.verificationCode" style="width:60%;margin-right:5px"></el-input
                > 
              </el-form-item>
              <el-form-item>
                <el-button style="margin-left:10%" type="success" @click="submitForm('formLabelAlign')"
                  >登录</el-button
                >
                <el-button @click="resetForm('formLabelAlign')">取消</el-button>
              </el-form-item>
            </div>
            <div v-if="activeName == 'third'" style="text-align:center">
              <img src="../assets/wgsewm.png" width="40%" />
            </div>
          </el-form>
        </el-tabs>
      </div>
    </div>
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
 
  </div>
</template>

<script>
// @ is an alias to /src
// import Foot from "@/components/Footer.vue";
import "../static/css/my.css";
export default {
  name: "Login",
  data() {
    return {
      mtvalue: 0,
      activeName: "first",
      formLabelAlign: {
        name: "",
        pwd: "",
        phoneNumber: "",
        verificationCode:''
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$router.push("/serviceHome");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleClick(tab, event) {
      console.log(tab, event);
      if (tab.index == 0 || tab.index == "0") {
        this.activeName = "first";
      }
      if (tab.index == 1 || tab.index == "1") {
        this.activeName = "second";
      }
      if (tab.index == 2 || tab.index == "2") {
        this.activeName = "third";
      }
    },
    sendCode() {},
  },
  mounted() {
    const wheight = window.screen.height;
    this.mtvalue = (wheight - 660) * 0.5;
  },
  components: {
    // Foot,
  },
};
</script>
<style>
.topBox {
  background: url(../assets/bg2.jpg) center top no-repeat;
  background-size: 100% 100%;
  height: calc(100% - 0px);
  padding-top: 20px;
}
.topBox a{color: #008942;padding:0 5px;text-decoration: none;  }
</style>